import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { store }  from './store';
import CaAccountMenu from "./components/CaAccountMenu";
import CaAccountModal from "./components/accountModal/CaAccountModal";
import CaQuizContainer from "./components/CaQuizContainer";
import CaProfileContainer from "./components/profile/CaProfileContainer";
import CaQuizzesContainer from "./components/quizzes/CaQuizzesContainer";
import CaQuizToutContainer from "./components/general/CaQuizToutContainer";
import CaQuizAdmin from "./components/admin/CaQuizAdmin";


window.caAccountMenuCreate = function (elementId, iconsBasePath) {
    const element = document.getElementById(elementId);
    ReactDOM.render( 
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <CaAccountMenu iconsBasePath={iconsBasePath}/>
            </Provider>
        </I18nextProvider>, element);
};

window.caAccountModalCreate = function (elementId, iconsBasePath) {
    const element = document.getElementById(elementId);
    ReactDOM.render( 
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <CaAccountModal iconsBasePath={iconsBasePath}/>
            </Provider>
        </I18nextProvider>, element);
};

window.caQuizCreate = function (elementId, quizData, iconsBasePath) {
    const element = document.getElementById(elementId);
    ReactDOM.render( 
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <CaQuizContainer data={quizData} iconsBasePath={iconsBasePath} />
            </Provider>
        </I18nextProvider>, element);
};

window.caQuizzesCreate = function (elementId, quizData, iconsBasePath) {
    const element = document.getElementById(elementId);
    ReactDOM.render( 
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <CaQuizzesContainer quizData={quizData} iconsBasePath={iconsBasePath} />
            </Provider>
        </I18nextProvider>, element);
};

window.caProfilePageCreate = function (elementId, quizData, levelsData, pageImage, iconsBasePath) {
    const element = document.getElementById(elementId);
    ReactDOM.render( 
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <CaProfileContainer quizData={quizData} levelsData={levelsData} pageImage={pageImage} iconsBasePath={iconsBasePath} />
            </Provider>
        </I18nextProvider>, element);
};
window.caQuizPuffCreate = function (elementId) {
   const  element = document.getElementById(elementId);
    ReactDOM.render( 
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <CaQuizToutContainer />
            </Provider>
        </I18nextProvider>, element);
};

window.caAdminCreate = function (elementId, quizId) {
    const element = document.getElementById(elementId);
    ReactDOM.render( 
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <CaQuizAdmin quizId={quizId} />
            </Provider>
        </I18nextProvider>, element);
};